import Axios, { AxiosRequestConfig } from 'axios';
import { decodeCookie } from '../../../lib/cookie-parser';

const paymentAPI = Axios.create({
  baseURL: process.env.REACT_APP_PAYMENT_API,
});

paymentAPI.interceptors.request.use(
  (config: AxiosRequestConfig): AxiosRequestConfig => {
    const cookie = decodeCookie();
    let token = cookie?.token;
    if (!token || token === 'undefined' || token === 'null') {
      try {
        token =
          window.localStorage.getItem('token') ||
          window.sessionStorage.getItem('token') ||
          '';
      } catch (e) {
        token = '';
      }
    }
    const interceptedConfig = config;
    const authHeader =
      token && token !== 'undefined' && token !== 'null'
        ? token.startsWith('Bearer ')
          ? token
          : `Bearer ${token}`
        : '';
    interceptedConfig.headers = {
      ...interceptedConfig.headers,
      Authorization: authHeader,
    };
    return interceptedConfig;
  }
);
export default paymentAPI;
